<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      eager
      scrollable
      max-width="900px"
      content-class="rounded-dialog"
    >
      <v-form ref="PerformanceTarget" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header">
            <div class="dialog-header-content">
              <div class="dialog-title-wrapper">
                <div class="dialog-icon">
                  <icon name="circle-add" />
                </div>

                <div class="dialog-text">
                  <div class="dialog-title">
                    {{ action }} {{ getMFODesc(target_type) }}
                    {{
                      data && data.isFaculty == true && data.target_for
                        ? "(" + data.target_for + ")"
                        : ""
                    }}
                  </div>

                  <div class="dialog-subtitle">
                    Fill in the required information below
                  </div>
                </div>
              </div>

              <v-btn icon class="close-btn" @click="closeD()">
                <icon name="circle-close" />
              </v-btn>
            </div>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  v-if="data && data.target_for != 'Instruction'"
                >
                  <div class="opcr-link-card">
                    <!-- Header -->
                    <div class="opcr-link-header">
                      <div>
                        <div class="opcr-title">
                          <v-icon size="18" color="#147452" class="mr-2">
                            mdi-link-variant
                          </v-icon>
                          Link OPCR Target
                        </div>

                        <div class="opcr-subtitle">
                          Select an OPCR target to associate with this entry.
                        </div>
                      </div>

                      <div>
                        <v-checkbox
                          v-if="isHeadOrAbove"
                          v-model="isLinkedToMyOPCR"
                          hide-details
                          label="My OPCR"
                          color="#147452"
                        />

                        <v-checkbox
                          v-if="!isHeadOrAbove"
                          v-model="isLinkedToMyHeadOPCR"
                          hide-details
                          label="Head OPCR"
                          color="#147452"
                        />
                      </div>
                    </div>

                    <!-- Content -->
                    <div class="mt-4">
                      <v-expand-transition>
                        <div
                          v-if="
                            isLinkedToMyOPCR &&
                              data &&
                              data.target_for != 'Instruction'
                          "
                        >
                          <v-autocomplete
                            v-model="linked_my_opcr_targetID"
                            outlined
                            class="rounded-lg"
                            label="Select OPCR Target"
                            item-text="mfo"
                            item-value="id"
                            :items="myopcrList"
                            color="#147452"
                            :rules="
                              isLinkedToMyOPCR ? [formRules.required] : []
                            "
                          />
                        </div>
                      </v-expand-transition>

                      <v-expand-transition>
                        <div v-if="isLinkedToMyHeadOPCR">
                          <v-autocomplete
                            v-model="linked_head_opcr_targetID"
                            outlined
                            class="rounded-lg"
                            label="Select OPCR Target"
                            item-text="mfo"
                            item-value="id"
                            :items="headopcrList"
                            color="#147452"
                            :rules="
                              isLinkedToMyHeadOPCR ? [formRules.required] : []
                            "
                          />
                        </div>
                      </v-expand-transition>
                    </div>
                  </div>
                </v-col>

                <v-col v-if="tab == 2 && data && data.isFaculty == true">
                  <v-autocomplete
                    v-model="facultySpSelected"
                    :rules="
                      tab == 2 && data && data.isFaculty == true
                        ? [formRules.required]
                        : []
                    "
                    outlined
                    class="rounded-lg"
                    item-text="desc"
                    item-value="id"
                    label="Strategic Priority Selection"
                    color="#147452"
                    :items="facultySpSelection"
                    @change="loadIPCRQuality()"
                  >
                  </v-autocomplete>
                </v-col>

                <v-col v-if="tab == 2 && data && data.isFaculty == true">
                  <v-autocomplete
                    v-model="facultySpToSave"
                    :rules="
                      tab == 2 && data && data.isFaculty == true
                        ? [formRules.required]
                        : []
                    "
                    outlined
                    class="rounded-lg"
                    item-text="mfo"
                    item-value="id"
                    :label="
                      `${
                        facultySpSelected
                          ? facultySpSelection[facultySpSelected - 1].desc
                          : ''
                      } Strategic Priorities`
                    "
                    color="#147452"
                    @change="
                      loadSPToFields();
                      loadIPCRQuality();
                    "
                    :items="
                      facultySpSelected == 1
                        ? facultySpList.research
                        : facultySpList.extensionAndProduction
                    "
                  >
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" class="mt-4">
                  <div
                    class="text-caption blue--text"
                    v-if="
                      data &&
                        data.isFaculty == true &&
                        (tab == 2 || data.target_for == 'Instruction')
                    "
                  >
                    <i
                      >Note : Checkboxes are auto-checked and cannot be
                      changed!</i
                    >
                  </div>
                  <div class="rating-card">
                    <div class="rating-header">
                      <div class="rating-title">
                        <v-icon size="18" color="#147452" class="mr-2">
                          mdi-star-outline
                        </v-icon>
                        Rating Criteria
                      </div>

                      <div class="rating-subtitle">
                        Uncheck criteria that should not be included in the
                        evaluation.
                      </div>
                    </div>

                    <v-row class="mt-2">
                      <v-col cols="12" md="4">
                        <div
                          class="metric-card"
                          :class="{ active: eff_is_rated }"
                        >
                          <v-switch
                            v-model="eff_is_rated"
                            hide-details
                            class="metric-checkbox"
                            color="#147452"
                            :readonly="
                              (data && data.target_for == 'Instruction') ||
                                (tab == 2 && data && data.isFaculty == true)
                            "
                          />

                          <div class="metric-content">
                            <div class="metric-code">E</div>
                            <div class="metric-title">Efficiency</div>
                          </div>
                        </div>
                      </v-col>

                      <v-col cols="12" md="4">
                        <div
                          class="metric-card"
                          :class="{ active: qly_is_rated }"
                        >
                          <v-switch
                            v-model="qly_is_rated"
                            hide-details
                            class="metric-checkbox"
                            color="#147452"
                            :readonly="
                              (data && data.target_for == 'Instruction') ||
                                (tab == 2 && data && data.isFaculty == true)
                            "
                          />

                          <div class="metric-content">
                            <div class="metric-code">Q</div>
                            <div class="metric-title">Quality</div>
                          </div>
                        </div>
                      </v-col>

                      <v-col cols="12" md="4">
                        <div
                          class="metric-card"
                          :class="{ active: timeliness_is_rated }"
                        >
                          <v-switch
                            v-model="timeliness_is_rated"
                            hide-details
                            class="metric-checkbox"
                            color="#147452"
                            :readonly="
                              (data && data.target_for == 'Instruction') ||
                                (tab == 2 && data && data.isFaculty == true)
                            "
                          />

                          <div class="metric-content">
                            <div class="metric-code">T</div>
                            <div class="metric-title">Timeliness</div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12" class="field=spacing">
                  <v-textarea
                    label="Major Final Output"
                    outlined
                    :readonly="tab == 2 && data && data.isFaculty == true"
                    v-model="mfo"
                    :rules="[formRules.required]"
                    class="rounded-lg"
                    color="#147452"
                  ></v-textarea>
                </v-col>

                <v-col cols="12">
                  <div class="indicator-card">
                    <!-- Header -->
                    <div v-if="target_type != 2" class="indicator-header">
                      <div class="indicator-title">
                        <v-icon size="18" color="#147452" class="mr-2">
                          mdi-chart-box-outline
                        </v-icon>
                        Success Indicator
                      </div>

                      <div class="indicator-subtitle">
                        Configure target measures and rating criteria.
                      </div>
                    </div>

                    <!-- Metrics -->
                    <v-row class="mt-2">
                      <!-- Efficiency -->
                      <v-col
                        cols="12"
                        md="4"
                        v-if="eff_is_rated && target_type != 3"
                      >
                        <div class="metric-section">
                          <div class="section-label">Efficiency</div>

                          <v-radio-group
                            v-model="efficiency_type"
                            @change="setEfficiency()"
                            mandatory
                            dense
                            row
                            hide-details
                          >
                            <v-radio label="Numeric" value="numeric" />
                            <v-radio label="Percentage" value="percentage" />
                          </v-radio-group>

                          <div class="metric-input">
                            <v-text-field
                              v-model="efficiency"
                              label="Target Value"
                              outlined
                              dense
                              type="number"
                              :disabled="efficiency_type == 'percentage'"
                              color="#147452"
                            />
                          </div>
                        </div>
                      </v-col>

                      <!-- Quality -->
                      <v-col cols="12" md="4" v-if="qly_is_rated">
                        <div class="metric-section">
                          <div class="section-label">Quality</div>

                          <div class="metric-input">
                            <v-autocomplete
                              v-model="quality"
                              outlined
                              dense
                              item-text="description"
                              item-value="id"
                              :items="qlyList"
                              label="Select Quality"
                              color="#147452"
                            />
                          </div>
                        </div>
                      </v-col>

                      <!-- Timeliness -->
                      <v-col cols="12" md="4" v-if="timeliness_is_rated">
                        <div class="metric-section">
                          <div class="section-label">Timeliness</div>

                          <div class="metric-input">
                            <v-autocomplete
                              v-model="timeliness_selected"
                              outlined
                              dense
                              item-text="description"
                              item-value="id"
                              :items="timelinessList"
                              label="Select Timeliness"
                              color="#147452"
                              @change="changeTimeliness()"
                            />
                          </div>
                        </div>
                      </v-col>
                    </v-row>

                    <!-- Preview -->
                    <div class="preview-section">
                      <div class="preview-label">Success Indicator Preview</div>

                      <div class="preview-note">
                        <v-icon size="14" color="#2196F3">
                          mdi-information-outline
                        </v-icon>

                        Edit the generated success indicator if necessary.
                      </div>

                      <v-textarea
                        v-model="success_indicator_preview"
                        outlined
                        rows="4"
                        color="#147452"
                        class="mt-3"
                      />
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>

            <v-btn class="btn-cancel" outlined @click="closeD()">
              Cancel
            </v-btn>

            <v-btn
              v-if="action == 'Add'"
              color="#519043"
              class="btn-save"
              @click="addnew()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              Save
            </v-btn>
            <v-btn
              v-if="action == 'Update'"
              color="#519043"
              class="btn-save"
              @click="update()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="3000"
    ></fade-away-message-component>
  </div>
</template>

<script>
import icon from "@/assets/icon.vue";
export default {
  components: {
    icon,
  },
  props: {
    data: null,
    target_type: null,
    ipcrID: null,
    action: null,
    year: null,
    tab: null,
  },

  data() {
    return {
      id: null,
      timeliness: null,
      timeliness_selected: null,
      success_indicator: null,
      t_num: null,
      t_add_desc: null,
      quality: null,
      efficiency: null,
      efficiency_type: null,
      eff_is_rated: true,
      qly_is_rated: true,
      timeliness_is_rated: true,
      dialog: false,
      qlyList: [],
      timelinessList: [],
      isSubmitLoading: false,
      myopcrList: [],
      headopcrList: [],
      isLinkedToMyOPCR: null,
      isLinkedToMyHeadOPCR: null,
      linked_my_opcr_targetID: null,
      linked_head_opcr_targetID: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      facultySpSelection: [
        { id: 1, desc: "Research" },
        { id: 2, desc: "Extension and Production" },
      ],
      facultySpList: [],
      facultySpSelected: null,
      facultySpToSave: null,
      mfoList: ["Core Functions", "Strategic Priority", "Support Functions"],
      mfo: null,
      mfoDescription: null,
      myOpcrID: null,
      myHeadOpcrID: null,
      prevSuccessIndicator: null,
      showResetBtn: false,
      targetFor: null,
      success_indicator_to_save: null,
      myTaggingType: null,
      is_suc_ind_updated: false,
    };
  },
  watch: {
    data: {
      handler(data) {
        // this.success_indicator_to_save = null;
        this.is_suc_ind_updated = false;
        this.success_indicator_preview = null;
        this.dialog = true;
        this.getMyOPCR();
        this.getDirectHead();
        this.getMyTaggingType();
        console.log("DATA", data);
        if (data.id) {
          this.getFacultySPSelectionForUpdate();
          this.id = data.id;
          this.mfo = data.mfo;
          this.success_indicator = data.success_indicator;
          this.timeliness = data.timeliness;
          this.quality = parseInt(data.quality_util_id);
          this.efficiency = data.efficiency;
          this.efficiency_type = data.efficiency_type;
          this.eff_is_rated = data.eff_is_rated;
          this.qly_is_rated = data.qly_is_rated;
          this.timeliness_is_rated = data.timeliness_is_rated;
          this.t_num = data.t_num;
          this.timeliness_selected = parseInt(data.timeliness_util_id);
          this.t_add_desc = data.t_add_desc;
          this.isLinkedToMyHeadOPCR =
            data.isLinkedToMyHeadOPCR == 1 ? true : false;
          this.isLinkedToMyOPCR = data.isLinkedToMyOPCR == 1 ? true : false;
          if (this.tab == 1) {
            this.linked_head_opcr_targetID = data.linked_head_opcr_targetID
              ? data.linked_head_opcr_targetID.toString()
              : null;
            this.linked_my_opcr_targetID = data.linked_my_opcr_targetID
              ? data.linked_my_opcr_targetID.toString()
              : null;
          } else {
            this.linked_head_opcr_targetID = data.linked_head_pap_taggedID
              ? data.linked_head_pap_taggedID.toString()
              : null;
            this.linked_my_opcr_targetID = data.linked_my_pap_taggedID
              ? data.linked_my_pap_taggedID.toString()
              : null;
          }

          // console.log("dasdad", data);
          this.showResetBtn = data.success_indicator != null;
          this.prevSuccessIndicator = null;
          if (data.isFaculty) {
            let idx = this.facultySpSelection.findIndex(
              (i) => i.desc == data.target_for,
            );

            this.facultySpSelected = idx + 1;
            this.facultySpToSave = data.ipcrFacultyCFSPUtil_ID;
          }
        } else {
          this.getFacultySPSelection();
          this.showResetBtn = false;
          this.id = null;
          this.mfo = null;
          this.timeliness = null;
          this.efficiency_type = null;
          this.quality = null;
          this.efficiency = null;
          this.eff_is_rated = 1;
          this.qly_is_rated = 1;
          this.timeliness_is_rated = 1;
          this.t_num = null;
          this.timeliness_selected = null;
          this.t_add_desc = null;
          if (this.isHeadOrAbove) {
            this.isLinkedToMyOPCR = true;
            this.isLinkedToMyHeadOPCR = false;
          } else {
            this.isLinkedToMyOPCR = false;
            this.isLinkedToMyHeadOPCR = true;
          }

          this.linked_head_opcr_targetID = null;
          this.linked_my_opcr_targetID = null;
          this.prevSuccessIndicator = null;
          this.facultySpSelected = null;
          this.facultySpToSave = null;
        }

        this.getIPCRQuality();
        this.getIPCRTimeliness();
      },

      deep: true,
    },

    success_indicator_to_save: {
      handler(newVal, oldVal) {
        this.is_suc_ind_updated = newVal !== oldVal;
      },
    },

    facultySpSelected: {
      handler(newVal, oldVal) {
        if (oldVal != newVal) {
          this.facultySpToSave = null;
        }
      },
    },
  },
  computed: {
    isHeadOrAbove() {
      return (
        this.$store.state.user.user.user_roleID != 2 &&
        this.$store.state.user.user.user_roleID != 5 &&
        this.$store.state.user.user.user_roleID != 10
      );
    },
    isToTimelinessNumber() {
      let toAdd = false;
      if (this.timeliness_selected) {
        for (let i = 0; i < this.timelinessList.length; i++) {
          if (this.timelinessList[i].id == this.timeliness_selected) {
            toAdd = this.timelinessList[i].toAddNumber;
          }
        }
      }
      return toAdd;
    },

    timelinessPreview() {
      let text = "";
      for (let i = 0; i < this.timelinessList.length; i++) {
        if (this.timelinessList[i].id == this.timeliness_selected) {
          text += this.timelinessList[i].description + " ";
        }
      }
      return text;
    },
    success_indicator_preview: {
      get() {
        let text = "";

        // if (this.action == "Add") {
        text = this.mfo ? this.mfo : "";

        if (this.eff_is_rated) {
          if (this.efficiency_type == "numeric") {
            if (this.efficiency) {
              text = this.efficiency + "/" + this.efficiency + " " + text;
            }
          } else {
            if (this.efficiency) {
              text = "100% " + text;
            }
          }
        }

        if (this.qly_is_rated && this.quality) {
          text += " " + this.getQualityDesc;
        }

        if (this.timeliness_is_rated && this.timeliness_selected) {
          text += " " + this.timelinessPreview;
        }
        // } else {
        //   text = this.data?.success_indicator || "";
        // }

        return text;
      },
      set(val) {
        // this.success_indicator_preview = val;
        this.success_indicator_to_save = val;
      },
    },

    // success_indicator_preview: {
    //   get() {
    //     let text = "";
    //     if (this.action == "Update") {
    //       text = this.mfo ? this.mfo : "";
    //       if (this.eff_is_rated) {
    //         if (this.efficiency_type == "numeric") {
    //           if (this.efficiency)
    //             text = this.efficiency + "/" + this.efficiency + " " + text;
    //         } else {
    //           if (this.efficiency) text = "100% " + text;
    //         }
    //       }
    //       if (this.qly_is_rated) {
    //         if (this.quality) text += " " + this.getQualityDesc;
    //       }
    //       if (this.timeliness_is_rated) {
    //         if (this.timeliness_selected) text += " " + this.timelinessPreview;
    //       }
    //     } else {
    //       text = this.data.success_indicator;
    //     }

    //     return text;
    //   },
    //   set(val) {
    //     this.success_indicator_to_save = val;
    //   },

    //   //
    // },

    getQualityDesc() {
      let text = "";
      if (this.quality) {
        for (let i = 0; i < this.qlyList.length; i++) {
          if (this.qlyList[i].id == this.quality) {
            text = this.qlyList[i].description;
          }
        }
      }
      return text;
    },
  },

  methods: {
    initialize() {},
    getMFODesc(id) {
      return this.mfoList[id - 1];
    },
    changeTimeliness() {
      this.t_num = null;
      this.t_add_desc = null;
    },
    closeD() {
      this.eventHub.$emit("closeIPCRFunctionDialog", false);
      this.initialize();
      this.isSubmitLoading = false;
      this.dialog = false;
    },

    resetSuccessIndicator() {
      this.prevSuccessIndicator = this.success_indicator;
      this.success_indicator = null;
    },

    undoSuccessIndicatorReset() {
      this.efficiency = this.data.efficiency;
      this.quality = parseInt(this.data.quality_util_id);
      this.timeliness = this.data.timeliness;
      this.timeliness_selected = this.data.timeliness_util_id;
      this.success_indicator = this.prevSuccessIndicator;
      this.prevSuccessIndicator = null;
    },

    loadSPToFields() {
      let data =
        this.facultySpSelected == 1
          ? this.facultySpList.research
          : this.facultySpList.extensionAndProduction;
      let index = data.findIndex((obj) => obj.id === this.facultySpToSave);
      this.eff_is_rated = data[index].eff_is_rated;
      this.qly_is_rated = data[index].qly_is_rated;
      this.timeliness_is_rated = data[index].timeliness_is_rated;
      this.mfo = data[index].mfo;
      this.targetFor = this.facultySpSelection[this.facultySpSelected - 1].desc;
    },

    setEfficiency() {
      if (this.efficiency_type == "percentage") {
        this.efficiency = 100;
      } else {
        this.efficiency = null;
      }
    },

    addnew() {
      if (this.$refs.PerformanceTarget.validate()) {
        this.isSubmitLoading = true;
        let data = {
          ipcr_ID: this.ipcrID,
          target_type: this.target_type,
          mfo: this.mfo,
          efficiency: this.target_type != 3 ? this.efficiency : null,
          efficiency_type: this.target_type != 3 ? this.efficiency_type : null,
          quality_util_id: this.quality,
          quality: this.getQualityDesc,
          // quality: this.quality,
          // timeliness: this.timeliness,
          timeliness: this.timelinessPreview,
          t_num: this.t_num,
          t_add_desc: this.t_add_desc,
          timeliness_util_id: this.timeliness_selected,
          eff_is_rated: this.eff_is_rated,
          qly_is_rated: this.qly_is_rated,
          timeliness_is_rated: this.timeliness_is_rated,
          isLinkedToMyOPCR: this.isLinkedToMyOPCR,
          isLinkedToMyHeadOPCR: this.isLinkedToMyHeadOPCR,
          linked_my_opcr_targetID: this.isLinkedToMyOPCR
            ? this.linked_my_opcr_targetID
            : null,
          linked_head_opcr_targetID: this.isLinkedToMyHeadOPCR
            ? this.linked_head_opcr_targetID
            : null,
          target_for:
            this.tab == 1
              ? this.data.isFaculty
                ? "Designation"
                : null
              : this.targetFor,
          ipcrFacultyCFSPUtil_ID: this.tab == 2 ? this.facultySpToSave : null,
          success_indicator: this.success_indicator_to_save
            ? this.success_indicator_to_save
            : this.success_indicator_preview,
        };
        // console.log(data);
        this.axiosCall("/ipcr-target", "POST", data).then((res) => {
          console.log(res);
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;

            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },

    update() {
      if (this.$refs.PerformanceTarget.validate()) {
        this.isSubmitLoading = true;
        let data = {
          ipcr_ID: this.ipcrID,
          target_type: this.target_type,
          mfo: this.mfo,
          efficiency: this.target_type != 3 ? this.efficiency : null,
          efficiency_type: this.target_type != 3 ? this.efficiency_type : null,
          // quality: this.quality,
          // timeliness: this.timeliness,
          quality_util_id: this.quality,
          quality: this.getQualityDesc,
          timeliness: this.timelinessPreview,
          t_num: this.t_num,
          t_add_desc: this.t_add_desc,
          timeliness_util_id: this.timeliness_selected,
          eff_is_rated: this.eff_is_rated,
          qly_is_rated: this.qly_is_rated,
          timeliness_is_rated: this.timeliness_is_rated,
          isLinkedToMyOPCR: this.isLinkedToMyOPCR,
          isLinkedToMyHeadOPCR: this.isLinkedToMyHeadOPCR,
          linked_my_opcr_targetID: this.isLinkedToMyOPCR
            ? this.linked_my_opcr_targetID
            : null,
          linked_head_opcr_targetID: this.isLinkedToMyHeadOPCR
            ? this.linked_head_opcr_targetID
            : null,
          success_indicator: this.success_indicator_to_save
            ? this.success_indicator_to_save
            : this.success_indicator_preview,
        };
        console.log(
          "update ",
          data,
          this.is_suc_ind_updated,
          this.success_indicator_to_save,
          this.success_indicator_preview,
        );
        this.axiosCall("/ipcr-target/" + this.id, "PATCH", data).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },

    getIPCRQuality() {
      console.log("LOAD QLY ", this.data);
      let url = "";

      if (this.data.isFaculty) {
        if (this.data.target_for == "Instruction") {
          if (
            this.data.ipcrFacultyCFSPUtil_ID &&
            (this.data.ipcrFacultyCFSPUtil_ID == 1 ||
              this.data.ipcrFacultyCFSPUtil_ID == 5)
          ) {
            url =
              "/ipcr-quality-util/Instruction/" +
              this.data.ipcrFacultyCFSPUtil_ID;
          } else {
            url = "/ipcr-quality-util";
          }
        } else if (this.data.target_for == "Designation") {
          url = "/ipcr-quality-util";
        } else if (this.data.target_for == "Research") {
          url =
            "/ipcr-quality-util/Research/" + this.data.ipcrFacultyCFSPUtil_ID;
        } else if (this.data.target_for == "Extension and Production") {
          url =
            "/ipcr-quality-util/Extension and Production/" +
            this.data.ipcrFacultyCFSPUtil_ID;
        } else {
          url = "/ipcr-quality-util";
        }
      } else {
        url = "/ipcr-quality-util";
      }

      this.axiosCall(url, "GET").then((res) => {
        this.qlyList = res.data;
      });
    },

    loadIPCRQuality() {
      console.log(
        "LOAD QLY ",
        this.data,
        this.facultySpSelected,
        this.facultySpToSave,
      );
      let url = "";
      if (this.facultySpSelected && this.facultySpToSave) {
        let target_for = this.facultySpSelection[this.facultySpSelected - 1]
          .desc;
        url = "/ipcr-quality-util/" + target_for + "/" + this.facultySpToSave;
        this.axiosCall(url, "GET").then((res) => {
          this.qlyList = res.data;
        });
      }
    },

    getIPCRTimeliness() {
      this.axiosCall("/ipcr-timeliness-util", "GET").then((res) => {
        this.timelinessList = res.data;
      });
    },

    getMyOPCR() {
      // let filter = this.$store.getters.getFilterSelected;
      //fetching MyOPCR data for the current year
      this.axiosCall(
        "/opcr-target/getMyOPCR/" + this.year + "/" + this.tab,
        "GET",
      ).then((res) => {
        this.myOpcrID = res.data.opcrID;
        let data = res.data.trgt;
        data.forEach((element, i) => {
          data[i].mfo =
            this.toTitleCase(element.mfo) +
            (element.code ? " (" + element.code + ")" : "");
        });
        this.myopcrList = res.data.trgt;
      });
    },

    getHeadOPCR(id) {
      // let filter = this.$store.getters.getFilterSelected;
      //fetching Head OPCR data for the current year

      this.axiosCall(
        "/opcr-target/getHeadOPCR/" + this.year + "/" + id + "/" + this.tab,
        "GET",
      ).then((res) => {
        console.log("Head", res.data);
        this.myHeadOpcrID = res.data.opcrID;
        this.headopcrList = res.data.trgt;
      });
    },

    getFacultySPSelection() {
      let year = this.data.year;
      this.axiosCall(
        "/ipcr-support-util/getFacultySPSelection?year=" + year,
        "GET",
      ).then((res) => {
        this.facultySpList = res.data;
      });
    },

    getFacultySPSelectionForUpdate() {
      let year = this.data.year;
      this.axiosCall(
        "/ipcr-support-util/getFacultySPSelectionForUpdate?year=" +
          year +
          "&id=" +
          this.data.id,
        "GET",
      ).then((res) => {
        this.facultySpList = res.data;
      });
    },

    getEmpDetails() {
      this.axiosCall("/employee/my-details", "GET").then((res) => {
        console.log(res.data);
        this.assigned_office = res.data.officeID;
      });
    },

    getOffices() {
      this.axiosCall("/offices", "GET").then((res) => {
        this.officeList = res.data;
      });
    },

    getDesignations() {
      this.axiosCall("/designations", "GET").then((res) => {
        this.designationList = res.data;
      });
    },
    getDirectHead() {
      this.axiosCall("/my-direct-head/getMyDirectHead", "GET").then((res) => {
        if (res.data) {
          if (res.data.length > 0) {
            this.getHeadOPCR(res.data[0].userID);
          }
        }
      });
    },
    getMyTaggingType() {
      this.axiosCall("/opcr-target/getMyTaggingType", "GET").then((res) => {
        console.log("Tagging Type", res.data);
        this.myTaggingType = res.data;
      });
    },
  },
};
</script>
